module.exports = __webpack_public_path__ + "static/media/slider-img1.3a1512c5.png";